import React from 'react';
import { connect } from 'react-redux';

import HtmlPackageSection from './html_package.jsx';

import {
  getRenderAsMobile,
  getSectionSingletonContentItem,
  getAssetForContent
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  getHeightStyle,
  getIsVisibleOnMobile
} from 'zoomforth_codesbane_viewer/lib/sections.js';

import userAgentDetect from 'zoomforth_zfutils/useragent_detect.js';

const mapStateToProps = (state, { section }) => {
  const isMobile = getRenderAsMobile(state) || userAgentDetect.isMobile.isAnyRealDevice();
  const contentItem = getSectionSingletonContentItem(state, section);
  const asset = getAssetForContent(state, contentItem);
  const height = getHeightStyle(section);
  return {
    height,
    isMobile,
    shouldShowSkipLink: true,
    uuid: contentItem ? contentItem.uuid : null,
    htmlPackageEntrypointUrl: asset ? asset.entrypointUrl : null,
    iframeTitle: contentItem ? contentItem.iframe_title : null,
  };
};

const mapDispatchToProps = () => ({});

const HtmlPackageSectionSwitcher = ({ isMobile, ...props }) => {
  if (!props.htmlPackageEntrypointUrl) {
    return null;
  } else if (isMobile && !getIsVisibleOnMobile(props.section)) {
    return null;
  }
  return <HtmlPackageSection {...props} />;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HtmlPackageSectionSwitcher);
